import React from "react";
import ReactDOMClient from "react-dom/client";
import { Screen } from "./screens";

const app = document.getElementById("app");
const root = ReactDOMClient.createRoot(app);
root.render(<Screen />);
